export default import.meta.ROLLUP_FILE_URL_PWd8aapBt1YfLvgRaedarQ;